import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  show: false,
  type: 'success',
  title: '',
  message: '',
}

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: initialState,
  reducers: {
    showNotification: (state, action) => {
      return {
        ...state,
        ...action.payload,
      }
    },
    resetNotifications: () => initialState,
  },
})

export const {showNotification, resetNotifications} = notificationsSlice.actions

export const notificationsReducer = notificationsSlice.reducer
